import type { LanguageCode } from 'charting-library'

export const TRADING_VIEW_LANG_MAP: Record<string, LanguageCode> = {
  zh_CN: 'zh',
  en: 'en',
  zh_HK: 'zh_TW',
  ar: 'ar',
  ja: 'ja',
  ko: 'ko',
  fr: 'fr',
  es: 'es',
  ru: 'ru',
  de: 'de',
  pt: 'pt',
  hi: 'he_IL',
  vi: 'vi',
  th: 'th',
  tr: 'tr',
  it: 'it',
  id: 'id_ID',
}
